import { useCallback } from 'react';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import ListingLibDateTimeCell from 'framework-listing-lib/table/ListingLibDateTimeCell';
import { PROPERTIES } from '../constants';
import { FormType } from '../types';
import UnavailableNonHubSpotData from '../UnavailableNonHubSpotData';
import { jsx as _jsx } from "react/jsx-runtime";
function DateTimeCell({
  crmObject,
  propertyName
}) {
  const propertyValue = getPropertyValue(crmObject, propertyName);
  const getSecondaryPropertyValue = useCallback(name => getPropertyValue(crmObject, name), [crmObject]);
  const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
  if (formType === FormType.CAPTURED) return /*#__PURE__*/_jsx(UnavailableNonHubSpotData, {});
  return /*#__PURE__*/_jsx(ListingLibDateTimeCell, {
    crmObject: crmObject,
    propertyName: propertyName,
    value: propertyValue,
    getSecondaryPropertyValue: getSecondaryPropertyValue
  });
}
export const dateTimeCell = {
  width: 175,
  multiline: true,
  renderCell: props => /*#__PURE__*/_jsx(DateTimeCell, Object.assign({}, props))
};